import GroupPicker from './GroupPicker'

export default GroupPicker
